import { useEffect, useState } from 'react';
import LangEnum from '../../../lang/LangEnum';
import { useFindSalesRepresentatives } from '../../../services/modules/salesRepresentatives/salesRepresentatives.queries';
import snackbarStore from '../../../stores/Snackbar.store';
import { useTranslation } from '../../translation/TranslationContext';
import { SalesRepresentativeOption } from '../myNetwork.types';

const SALES_REPRESENTATIVES_LIMIT = 999;

const useEditSalesRepModalOptions = (isEnabled: boolean) => {
  const { handleMessage } = snackbarStore;
  const { translate } = useTranslation();
  const [inputText, setInputText] = useState('');

  const salesRepresentativesQuery = useFindSalesRepresentatives(
    {
      nameOrCode: inputText,
      active: true,
      limit: SALES_REPRESENTATIVES_LIMIT,
      skip: 0,
      'order[name]': 'ASC',
    },
    { enabled: isEnabled },
    { keepPreviousData: true },
  );

  useEffect(() => {
    if (salesRepresentativesQuery.isError) {
      handleMessage({
        type: 'error',
        message: translate(LangEnum.MY_NETWORK_EDIT_SALES_REP_LOADING_SELLERS_ERROR),
      });
    }
  }, [salesRepresentativesQuery.isError, handleMessage, translate]);

  const options: SalesRepresentativeOption[] = salesRepresentativesQuery.data?.data ?? [];

  return {
    options,
    isLoadingOptions: salesRepresentativesQuery.isFetching,
    setInputText,
  };
};

export default useEditSalesRepModalOptions;
